import { phpRequest } from "./phpRequest";

export const deleteCompanyGroupAPI = (id) => {
  return phpRequest.delete("/company/group/delete", {
    id,
  });
};
